/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Action/Template
 * @desc Creates an ExperimentWorkflow from a template one
 */

import { EntityActionDuplicate } from 'labstep-web/components/Entity/Action/Duplicate';
import { ICONS } from 'labstep-web/constants/icons';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type React from 'react';
import type { ExperimentWorkflowActionTemplateProps } from './types';

export const ExperimentWorkflowActionTemplate: React.FC<
  ExperimentWorkflowActionTemplateProps
> = ({ experimentWorkflow }) => (
  <EntityActionDuplicate
    dataCy="components/ExperimentWorkflow/Action/Template:Duplicate"
    entity={experimentWorkflow}
    body={{
      is_template: !experimentWorkflow.is_template,
    }}
    actionComponentProps={{
      type: 'option',
      icon: experimentWorkflow.is_template
        ? ICONS.experiment_workflow.primary
        : ICONS.experiment_workflow.template,
      text: experimentWorkflow.is_template
        ? `Create ${ExperimentWorkflow.getHumanReadableEntityName(
            false,
            true,
          )}`
        : `Save as Template`,
    }}
  />
);
